import { render, staticRenderFns } from "./OtpsDetails.vue?vue&type=template&id=0ed72614&"
import script from "./OtpsDetails.vue?vue&type=script&lang=js&"
export * from "./OtpsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports